import { render, staticRenderFns } from "./TechDetailPage.vue?vue&type=template&id=475b6f2d&scoped=true"
import script from "./TechDetailPage.vue?vue&type=script&lang=js"
export * from "./TechDetailPage.vue?vue&type=script&lang=js"
import style0 from "./TechDetailPage.vue?vue&type=style&index=0&id=475b6f2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b6f2d",
  null
  
)

export default component.exports